<template>
    <div class="site">

        <div class="menuButtons">
            <MenuButton  :icons="[require('../assets/img/deviceList_S.png'),require('../assets/img/deviceList_U.png'),]" title="设备列表" 
            @click="menu === 1 ? menu = -1 : menu = 1" @on="showDeviceList(true)" @off="showDeviceList(false)"
            :selected="menu === 1"/>

            <MenuButton  :icons="[require('../assets/img/monitorS.png'),require('../assets/img/monitor_U.png'),]" title="安防监控" 
            @click="menu === 2 ? menu = -1 : menu = 2" @on="showMonitorList(true)" @off="showMonitorList(false)"
            :selected="menu === 2"/>

            <MenuButton  :icons="[require('../assets/img/接线图1.png'),require('../assets/img/接线图2.png'),]" title="接线图" 
            @click="isShowDiagram = !isShowDiagram"  @on="Diagram()" @off="Diagram1"
            :selected="isShowDiagram"/> 
        </div>

        <!-- <ParkOverView /> -->
        <!-- 变压器负载 -->
        <TransformerLoad />
        <!-- 进线 -->
        <IntoLine />
        <!-- 用电统计 -->
        <Electricity />
        <!-- 回路监测 -->
        <LoopMonitoring />
        <!-- 安防监控 -->
        <SiteMonitor :areaId="areaId"/>
        <!-- <SiteMonitorYSY :areaId="areaId"/> -->

        
        <!-- 设备列表 -->
        <DeviceList :areaId="areaId" @showDevice="showDevice" ref="device" v-show="isShowDeviceList"/>
        <!-- 监控列表-->
        <MonitorList :areaId="areaId" v-show="isShowMonitorList" @showMonitor="showMonitor"/>
        <!-- 站点接线图 -->
        <SiteViewDiagram @showDiagram="showDiagram" v-show="isShowDiagram"/>


        <iframe name="THREE" id="#iframe" frameborder="0" width="100%" height="100%" ref="iframeThree" allowfullscreen="true"
            :src="url + $store.getters.getThreeUrl(areaId)">
        </iframe>

        <!-- <iframe name="THREE" id="#iframe" frameborder="0" width="100%" height="100%" ref="iframeThree"
            src="http://127.0.0.1:5500/public/level/CSKT.html">
        </iframe> -->

        <!-- <iframe name="THREE" id="#iframe" frameborder="0" width="100%" height="100%" ref="iframeThree" allowfullscreen="true"
            src="">
        </iframe> -->
    </div>
</template>

<script>
const MenuButton = () => import("../components/menuButton/menuButton.vue")
const ParkOverView = () => import('./components/ParkOverView.vue')
const Electricity = () => import('./siteCompont/Electricity.vue')
const TransformerLoad = () => import('./siteCompont/TransformerLoad.vue')
const DeviceList = () => import('./siteCompont/DeviceList.vue')
const MonitorList = () => import('./siteCompont/MonitorList.vue')
const IntoLine = () => import('./siteCompont/IntoLine.vue')
const LoopMonitoring = () => import('./siteCompont/LoopMonitoring.vue')
const SiteMonitor = () => import('./siteCompont/SiteMonitor.vue')
const SiteViewDiagram = () => import('./siteCompont/SiteViewDiagram.vue')
const SiteMonitorYSY = () => import('./siteCompont/SiteMonitorYSY')



import { config } from '../config'
export default {
    data(){
        return {
            url: config.threeUrl,
            areaId:'',
            menu:-1,
            isShowDeviceList:false,
            isShowMonitorList:false,
            isShowDiagram:false,
        }
    },
    components:{
        MenuButton,
        ParkOverView,
        TransformerLoad,
        IntoLine,
        Electricity,
        LoopMonitoring,
        SiteMonitor,
        DeviceList,
        MonitorList,
        SiteViewDiagram,
        SiteMonitorYSY
    },
    created(){
        this.areaId = this.$route.params.id
        console.log('-----------------------'+this.areaId);
        this.$store.commit('set_siteId',this.areaId)
        
    },
    mounted(){
        this.iframeWin = this.$refs.iframeThree.contentWindow;
        this.$store.commit('set_page',0)
        
        setTimeout(()=>{
            this.menu = 1
        },100)

        window.addEventListener("message",this.handleMessage)
    },
    beforeDestroy() {
        window.removeEventListener("message", this.handleMessage);
    },
    methods:{
        showDeviceList(flag){
            this.isShowDeviceList = flag
        },
        showMonitorList(flag){
            this.isShowMonitorList = flag
            if(flag){
                this.sendMessage('siteSafety')
                console.log('打开摄像头');
            }else{
                this.sendMessage('clearSiteSafety')
            }
        },
        // 发送信息
        sendMessage(value,obj) {
            if(obj){
                this.iframeWin.postMessage({
                    cmd: value,
                    data:obj
                }, "*")
            }else{
                this.iframeWin.postMessage({
                    cmd: value,
                }, "*")
            }
        },
        // 监听接收信息
        handleMessage(event){
            let data = event.data
            switch (data.cmd) {
                case "showDeviceDetail":
                    console.log(data);
                    this.$refs.device.showDetail = true
                    this.$refs.device.modelId = data.params.data
                    break;
            }
        },
        // 显示接线图
        showDiagram(flag){
            this.isShowDiagram = flag
        },
        // 控制开关
        Diagram(){
            this.menu = 3
        },
        Diagram1(){
            if(this.menu == 3){
                this.menu = -1
            }
        },
        // 传值到站房内展示设备
        showDevice(obj){
            this.sendMessage('showDevice',obj)
            console.log(obj);
        },
        showMonitor(obj){
            this.sendMessage('monitor',obj)
        }
    }
}
</script>

<style lang="less" scoped>
    .site{
        width: 100%;
        height: 100%;
        .menuButtons{
            width: 10vw;
            height: 7vh;
            position: fixed;
            top: 6.8vh;
            left: 22.5vw;
            display: flex;
            flex-direction: row;
        }
    }
</style>